angular.module('TurneroApp').component('coUsuariosModificar', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlPadre: '='
    },
    controller: [
        'usuariosService',
        'utilsService',
        'TurneroAppConstant',
        function (usuariosService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.CidiInfo = {};
            ctrl.CiDiCuil = "";
            ctrl.CiDiencontrado = false;
            ctrl.rolesModificar = [];
            ctrl.usuarioEditar = {}
            ctrl.errores = {
                cuil: false,
                roles: false,
                rolesSU: false
            };

            ctrl.limpiarVariables = function () {
                ctrl.CidiInfo = {};
                ctrl.CiDiCuil = "";
                ctrl.CiDiencontrado = false;
                ctrl.rolesModificar = [];
                ctrl.usuarioEditar = {}
                ctrl.errores = {
                    cuil: false,
                    roles: false,
                    rolesSU: false
                };
            }

            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoadModificar = function (item) {
                    ctrl.limpiarVariables();

                    if (item && item.Id_centro_usuario) {
                        usuariosService.getInfo({ 'Id_Centro_Usuario': item.Id_centro_usuario, 'id_usuario': 0 }).$promise.then(function (res) {
                            ctrl.usuarioEditar = res;
                            ctrl.getCidi(res.N_Usuario);
                            ctrl.obtenerRolesHabilitados(res);
                            ctrl.usuarioEditar.N_Centro_Atencion = ctrl.centroAtencionSeleccionado.text;
                            ctrl.usuarioEditar.Id_Centro_Usuario = item.Id_centro_usuario;
                        }).catch(function (req) {
                            utilsService.errores(req);
                        });
                    }
                }
            }

            ctrl.$onChanges = function () {
                
            }

            ctrl.guardarUsuarioModificado = function () {
                ctrl.errores.cuil = !ctrl.CidiInfo.Return.Cuil;

                if (ctrl.usuarioEditar.RolesModificados != undefined) {
                    if (ctrl.usuarioEditar.RolesModificados.length === 0) {
                        ctrl.errores.roles = true;
                    }
                    else {
                        ctrl.errores.roles = false;
                    }
                }
                else {
                    ctrl.errores.roles = false;
                }

                if (ctrl.errores.cuil || ctrl.errores.roles || ctrl.errores.rolesSU) {
                    return;
                }

                ctrl.usuarioEditar.N_Usuario = ctrl.CidiInfo.Return.Cuil;
                ctrl.asignarAltasyBajas();

                if (ctrl.usuarioEditar.RolesModificados) {
                    if (!ctrl.usuarioEditar.RolesModificados || ctrl.usuarioEditar.RolesModificados.length) {
                        usuariosService.update(ctrl.usuarioEditar).$promise.then(function (res) {
                            ctrl.ctrlPadre.grillaReload();
                            ctrl.limpiarVariables();
                            sweetAlert("Modificar Usuario", "El usuario se modificó correctamente", "success");
                        }).catch(function (req) {
                            utilsService.errores(req);
                        });
                    } else {
                        sweetAlert("Usuario sin rol asignado.", "El usuario debe tener al menos un rol.", "error");
                    }
                };
            };

            ctrl.asignarAltasyBajas = function () {
                //limpio las listas, para que no quede basura en la variable del scope.
                ctrl.usuarioEditar.Id_Rol_Centro_Atencion_Baja = '';
                ctrl.usuarioEditar.Id_Rol_Alta = '';

                if (ctrl.usuarioEditar.RolesModificados != undefined) {
                    //en la lista de roles Usuarios, busco los que no estan en la lista de RolesModificados y los agrego para baja.
                    for (var i = 0; i < ctrl.usuarioEditar.Roles_Usuario.length; i++) {
                        var existe = false;
                        for (var j = 0; j < ctrl.usuarioEditar.RolesModificados.length; j++) {
                            if (ctrl.usuarioEditar.RolesModificados[j].Id_Rol == ctrl.usuarioEditar.Roles_Usuario[i].Id_Rol) {
                                existe = true;
                            }
                        }
                        if (!existe) {
                            ctrl.usuarioEditar.Id_Rol_Centro_Atencion_Baja = ctrl.usuarioEditar.Id_Rol_Centro_Atencion_Baja.length > 0 ?
                                ctrl.usuarioEditar.Id_Rol_Centro_Atencion_Baja + ',' + ctrl.usuarioEditar.Roles_Usuario[i].Id_Rol_Centro_Usuario.toString()
                                : ctrl.usuarioEditar.Roles_Usuario[i].Id_Rol_Centro_Usuario.toString();
                        }
                    }

                    //en la lista de roles modificados, busco los que no coinciden con RolesUsuarios y los agrego a la lista de Agregar.
                    for (var i = 0; i < ctrl.usuarioEditar.RolesModificados.length; i++) {
                        var existe = false;

                        for (var j = 0; j < ctrl.usuarioEditar.Roles_Usuario.length; j++) {
                            if (ctrl.usuarioEditar.RolesModificados[i].Id_Rol == ctrl.usuarioEditar.Roles_Usuario[j].Id_Rol) {
                                existe = true;
                            }
                        }
                        if (!existe) {
                            ctrl.usuarioEditar.Id_Rol_Alta = ctrl.usuarioEditar.Id_Rol_Alta.length > 0 ?
                                ctrl.usuarioEditar.Id_Rol_Alta + ',' + ctrl.usuarioEditar.RolesModificados[i].Id_Rol.toString()
                                : ctrl.usuarioEditar.RolesModificados[i].Id_Rol.toString();
                        }
                    }

                }
            };

            ctrl.cambiosEnRolesEdit = function (roles) {
                if (ctrl.ctrlPadre.validarSiTieneSU(roles)) {
                    ctrl.usuarioEditar.RolesModificados = roles;
                    ctrl.errores.rolesSU = false;
                }
                else {
                    ctrl.errores.rolesSU = true;
                }
            };

            ctrl.obtenerRolesHabilitados = function () {
                ctrl.rolesModificar = [];
                for (var i = 0; i < ctrl.usuarioEditar.Roles_Usuario.length; i++) {
                    ctrl.rolesModificar.push({
                        'Id_Rol': ctrl.usuarioEditar.Roles_Usuario[i].Id_Rol,
                        'Descripcion': ctrl.usuarioEditar.Roles_Usuario[i].Descripcion
                    })
                }
                var Roles = [];
                for (var i = 0; i < ctrl.usuarioEditar.Roles.length; i++) {
                    Roles.push({
                        'Id_Rol': ctrl.usuarioEditar.Roles[i].Id_Rol,
                        'Descripcion': ctrl.usuarioEditar.Roles[i].Descripcion
                    })

                }
                ctrl.usuarioEditar.Roles = Roles;
            };

            ctrl.getCidi = function (N_Usuario) {
                if (!N_Usuario) {
                    ctrl.errores.cuil = true;
                    return;
                }
                usuariosService.getCiDiInfo({ 'CUIL': N_Usuario }).$promise.then(function (res) {
                    ctrl.CiDiencontrado = false;
                    ctrl.CidiInfo = res;
                    if (res.Return.NombreYApellido != null)
                        ctrl.CiDiencontrado = true;
                }).catch(function (req) {
                    var msj = "";
                    var errors = req.data.ExceptionMessage ? req.data.ExceptionMessage.split(",") : req.data.Message.split(",");

                    if (errors.length > 0) {
                        if (errors[0] = "USU_NOT") {
                            msj = "No se encontró el CUIL en Ciudadano Digital";
                        }
                        else {
                            msj = req.data.ExceptionMessage ? req.data.ExceptionMessage : req.data.Message;
                        }
                    }

                    sweetAlert("Oops...", "Algo ocurrió y no se pudo completar la acción. </br>" + msj, "warning");
                });
            };

            ctrl.quitarCidi = function () {
                ctrl.CiDiencontrado = false;
                ctrl.CidiInfo = {};
                ctrl.CiDiCuil = "";
            }

            ctrl.cancelar = function () {
                ctrl.limpiarVariables();
                ctrl.ctrlPadre.grillaReload();
            }
        }
    ],
    template: require('./usuariosModificar.html')
});


// WEBPACK FOOTER //
// ./app/components/usuarios/usuariosModificarComponent.js